import { Button, Link, Typography } from "@mui/material";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import useConfirm from "../../../hooks/useConfirm";
import { logout } from "../../../utils/Functions";
import authApi from "../../../utils/api/authApi";
import { useNavigate } from "react-router-dom";
import { ACCOUNT_DELETE_REQUEST_PAGE, LOGIN } from "../../../enums/UrlPaths";
import { ACTIVATE_USER } from "../../../enums/ApiPaths";
import { SnackbarContext } from "../../../contexts/Snackbar";
import { useGetUserId } from "../../../hooks/useUser";

// Despite the surrounding "Permanent Actions" section, this only ever
// deactivates the account (blocks login; touches no data, pets, or
// appointments) - logging back in normally reactivates it. Real, permanent
// deletion is a separate, staff-executed action requested via the link
// below, not something this button performs.
export default function DeleteAccount() {
  const { t } = useTranslation();
  const userId = useGetUserId();
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const navigate = useNavigate();
  const { confirm, ConfirmationDialog, getMessage } = useConfirm(
    null,
    t("DeactivateAccount"),
    t("Cancel"),
    "warning"
  );

  //Doesn't need to be handled by query
  async function handleDeactivateAccount() {
    getMessage(t("DeactivateAccountConfirmationMessage"));
    const ans = await confirm();
    if (ans) {
      try {
        await authApi.post(ACTIVATE_USER + userId);
        logout();
        navigate(LOGIN);
      } catch (error) {
        handleSnackbar("", "error");
      }
    }
  }
  return (
    <Fragment>
      <Button
        variant="contained"
        color="error"
        onClick={() => handleDeactivateAccount()}
        data-testid="profile.settings.deactivate-account.button"
      >
        {t("DeactivateAccount")}
      </Button>
      <Typography variant="body2" color="text.secondary" mt={1}>
        {t("AccountDeletionDisclaimerPrefix")}{" "}
        <Link href={ACCOUNT_DELETE_REQUEST_PAGE}>
          {t("AccountDeletionDisclaimerLink")}
        </Link>
      </Typography>
      <ConfirmationDialog />
    </Fragment>
  );
}
